import React from "react";
import OrderDetails from "../../components/Shop/OrderDetails";

const ProfileSellerOrderDetails = () => {
  return <OrderDetails />;
};

export default ProfileSellerOrderDetails;
